// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__10uZA","col":"CardReaderDesc_col__3hVtl","label":"CardReaderDesc_label__2joL4"};